export const environment = {
    apiStrapi: 'http://192.168.1.104:1337',
    api: 'https://us-west-2.cdn.hygraph.com/content/clydpvtzx07mv07ur5n7jjn8f/master',
    apiService: 'https://api.digitalsolutionsmyc.com.mx'
    // apiService: 'http://192.168.1.101:8000'
    // apiService: 'http://127.0.0.1:8000'
    // apiService: 'https://s6pb58kf-8000.usw3.devtunnels.msno cre'
};
